(function () {
  var lastGridAtcContext = null;

  var CART_ICON_HTML =
    '<svg class="m-svg-icon--medium" fill="currentColor" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" aria-hidden="true">' +
    '<path d="M352 128C352 57.42 294.579 0 224 0 153.42 0 96 57.42 96 128H0v304c0 44.183 35.817 80 80 80h288c44.183 0 80-35.817 80-80V128h-96zM224 48c44.112 0 80 35.888 80 80H144c0-44.112 35.888-80 80-80zm176 384c0 17.645-14.355 32-32 32H80c-17.645 0-32-14.355-32-32V176h48v40c0 13.255 10.745 24 24 24s24-10.745 24-24v-40h160v40c0 13.255 10.745 24 24 24s24-10.745 24-24v-40h48v256z"/>' +
    '</svg>';

  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      var args = arguments;
      var ctx = this;
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function isCartAddRequest(input) {
    var url = '';
    if (typeof input === 'string') {
      url = input;
    } else if (input && typeof input.url === 'string') {
      url = input.url;
    }
    return /\/cart\/add/i.test(url);
  }

  function clearGridAtcSpinner(root) {
    var scope = root && root.querySelectorAll ? root : document;

    if (lastGridAtcContext) {
      var node = lastGridAtcContext;
      while (node) {
        if (node.classList) node.classList.remove('m-spinner-loading');
        if (node.classList && node.classList.contains('m-product-card__action--grid-atc')) break;
        node = node.parentElement;
      }
    }

    scope.querySelectorAll(
      '.m-product-card__action--grid-atc .m-spinner-loading, ' +
        '.m-product-card__grid-atc-btn.m-spinner-loading, ' +
        'product-form.m-product-card__grid-atc-form.m-spinner-loading, ' +
        '.m-product-card__grid-atc-form.m-spinner-loading'
    ).forEach(function (el) {
      el.classList.remove('m-spinner-loading');
    });

    scope.querySelectorAll('.m-product-card__grid-atc-btn').forEach(function (btn) {
      btn.classList.remove('m-spinner-loading');
      var node = btn.parentElement;
      while (node) {
        if (node.classList && node.classList.contains('m-product-card__action--grid-atc')) {
          node.classList.remove('m-spinner-loading');
          break;
        }
        if (node.tagName === 'PRODUCT-FORM' || node.classList.contains('m-product-card__grid-atc-form')) {
          node.classList.remove('m-spinner-loading');
        }
        node = node.parentElement;
      }
    });
  }

  function scheduleSpinnerClear(root) {
    var delays = [0, 50, 150, 400, 800, 1500, 3000];
    delays.forEach(function (ms) {
      setTimeout(function () {
        clearGridAtcSpinner(root);
      }, ms);
    });

    var start = Date.now();
    var interval = setInterval(function () {
      clearGridAtcSpinner(root);
      if (Date.now() - start > 8000) clearInterval(interval);
    }, 100);
  }

  function ensureFetchPatch() {
    if (window.fetch && window.fetch.__gridAtcWrapped) return;
    patchFetchForCartAdd();
  }

  function patchFetchForCartAdd() {
    var nativeFetch = window.fetch && window.fetch.__gridAtcNative
      ? window.fetch.__gridAtcNative
      : window.fetch.bind(window);

    function wrappedFetch(input, init) {
      var promise = nativeFetch(input, init);
      if (!isCartAddRequest(input)) return promise;

      return promise.finally(function () {
        clearGridAtcSpinner();
      });
    }

    wrappedFetch.__gridAtcWrapped = true;
    wrappedFetch.__gridAtcNative = nativeFetch;
    window.fetch = wrappedFetch;
    window.__gridAtcFetchPatched = true;
  }

  function ensureGridAtcIcon(btn) {
    var iconWrap = btn.querySelector('.m-tooltip-icon');
    if (!iconWrap) {
      iconWrap = document.createElement('span');
      iconWrap.className = 'm-tooltip-icon m:block';
      var spinner = btn.querySelector('.m-spinner-icon');
      if (spinner && spinner.nextSibling) {
        btn.insertBefore(iconWrap, spinner.nextSibling);
      } else {
        btn.appendChild(iconWrap);
      }
    }
    if (!iconWrap.querySelector('svg')) {
      iconWrap.innerHTML = CART_ICON_HTML;
    }
  }

  function cleanProductCardGridAtcButtons(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.m-product-card__grid-atc-btn').forEach(function (btn) {
      btn.querySelectorAll('.m-tooltip__content, .m-add-to-cart--text, [data-atc-text]').forEach(function (el) {
        el.remove();
      });

      Array.from(btn.childNodes).forEach(function (node) {
        if (node.nodeType === 3 && node.textContent.trim()) {
          node.remove();
        }
      });

      Array.from(btn.children).forEach(function (child) {
        if (
          child.tagName === 'SPAN' &&
          !child.classList.contains('m-spinner-icon') &&
          !child.classList.contains('m-tooltip-icon') &&
          !child.querySelector('svg')
        ) {
          var text = (child.textContent || '').trim().toLowerCase();
          if (text.indexOf('add') !== -1 || text.indexOf('cart') !== -1 || text.indexOf('sold') !== -1) {
            child.remove();
          }
        }
      });

      ensureGridAtcIcon(btn);
    });
  }

  function patchProductFormSpinner() {
    var ProductForm = customElements.get('product-form');
    if (!ProductForm || ProductForm.prototype.__gridAtcSpinnerPatched) return;

    var originalToggleSpinner = ProductForm.prototype.toggleSpinner;
    var originalOnSubmitHandler = ProductForm.prototype.onSubmitHandler;

    ProductForm.prototype.toggleSpinner = function (loading) {
      if (typeof originalToggleSpinner === 'function') {
        originalToggleSpinner.call(this, loading);
      } else {
        this.classList.toggle('m-spinner-loading', !!loading);
      }

      if (!this.classList.contains('m-product-card__grid-atc-form')) return;

      var btn = this.querySelector('.m-product-card__grid-atc-btn');
      if (btn) {
        btn.classList.toggle('m-spinner-loading', !!loading);
      }

      if (!loading) {
        clearGridAtcSpinner(this);
      }
    };

    ProductForm.prototype.onSubmitHandler = function (e) {
      var self = this;
      var isGrid = this.classList.contains('m-product-card__grid-atc-form');

      if (!isGrid) {
        return originalOnSubmitHandler.call(this, e);
      }

      var result = originalOnSubmitHandler.call(this, e);
      scheduleSpinnerClear(self);
      return result;
    };

    ProductForm.prototype.__gridAtcSpinnerPatched = true;
  }

  function bindCartSpinnerReset() {
    if (window.__gridAtcSpinnerResetBound) return;
    window.__gridAtcSpinnerResetBound = true;

    var reset = function () {
      clearGridAtcSpinner();
    };

    document.addEventListener(
      'click',
      function (e) {
        var btn = e.target.closest('.m-product-card__grid-atc-btn');
        if (btn) lastGridAtcContext = btn;
      },
      true
    );

    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || !form.classList || !form.classList.contains('product-card-form')) return;
        var productForm = form.closest('product-form.m-product-card__grid-atc-form');
        if (!productForm) return;
        lastGridAtcContext = productForm.querySelector('.m-product-card__grid-atc-btn') || productForm;
        scheduleSpinnerClear(productForm);
      },
      true
    );

    function subscribeEvents() {
      if (!window.MinimogEvents) return false;
      var events = window.MinimogTheme && window.MinimogTheme.pubSubEvents;
      if (!events) return false;
      window.MinimogEvents.subscribe(events.cartUpdate, reset);
      window.MinimogEvents.subscribe(events.cartError, reset);
      return true;
    }

    if (!subscribeEvents()) {
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        if (subscribeEvents() || tries > 40) clearInterval(timer);
      }, 100);
    }

    function watchCartDrawer() {
      var cartDrawer = document.querySelector('m-cart-drawer');
      if (!cartDrawer || cartDrawer.dataset.gridAtcSpinnerWatch) return;
      cartDrawer.dataset.gridAtcSpinnerWatch = '1';
      new MutationObserver(function () {
        if (cartDrawer.classList.contains('m-cart-drawer--active')) {
          clearGridAtcSpinner();
        }
      }).observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
    }

    watchCartDrawer();
    document.addEventListener('page:loaded', watchCartDrawer);
  }

  window.cleanProductCardGridAtcButtons = cleanProductCardGridAtcButtons;
  window.clearProductCardGridAtcSpinner = clearGridAtcSpinner;

  function runClean() {
    cleanProductCardGridAtcButtons();
    document.querySelectorAll('.m-product-tabs--icon-atc').forEach(function (section) {
      cleanProductCardGridAtcButtons(section);
    });
  }

  var debouncedRun = debounce(runClean, 80);

  function observeProductTabs() {
    document.querySelectorAll('.m-product-tabs--icon-atc').forEach(function (el) {
      if (el.dataset.atcIconObserved) return;
      el.dataset.atcIconObserved = '1';
      new MutationObserver(debouncedRun).observe(el, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    });
  }

  function init() {
    ensureFetchPatch();
    patchProductFormSpinner();
    bindCartSpinnerReset();
    runClean();
    observeProductTabs();
    setTimeout(runClean, 300);
    setTimeout(runClean, 1000);

    setInterval(ensureFetchPatch, 2000);
  }

  function whenProductFormReady(cb) {
    if (customElements.get('product-form')) {
      cb();
      return;
    }
    customElements.whenDefined('product-form').then(cb);
  }

  ensureFetchPatch();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      whenProductFormReady(init);
    });
  } else {
    whenProductFormReady(init);
  }

  document.addEventListener('page:loaded', function () {
    whenProductFormReady(init);
  });

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.m-product-tabs--icon-atc')) {
      whenProductFormReady(init);
    }
  });
})();
